import {
  EMERGENCY_FETCHING,
  EMERGENCY_FAILED,
  EMERGENCY_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case EMERGENCY_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case EMERGENCY_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case EMERGENCY_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
